<template>
  <div class="max-w-lg">
    <h1 class="text-lg font-bold mb-5">Хэрэглэгчийн мэдээлэл</h1>
    <div>
      <my-input label="Овог" v-model="user.lastName" readonly />
      <my-input label="Нэр" v-model="user.firstName" readonly />
      <my-input label="И-Мейл" v-model="user.email" readonly />
      <my-input label="Хэрэглэгчийн нэр" v-model="user.username" readonly />
      <my-input label="Бүртгэсэн огноо" type="datetime" :modelValue="moment(user.createdAt).format('YYYY-MM-DD hh:mm:ss')" readonly />
      <my-input label="Сүүлд нууц үгээ сольсон огноо" type="datetime" :modelValue="moment(user.passwordAt).format('YYYY-MM-DD hh:mm:ss')" readonly />
      <div class="py-4 space-x-4">
        <router-link to="/password">
          <my-button type="primary" icon="key">Нууц үгээ солих</my-button>
        </router-link>
        <my-button type="error" icon="logout" @click="is_logout(true)">Системээс гарах</my-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['is_logout'])
  }
}
</script>
